
if (typeof window.AESubscriptionInfo !== 'function') {
  class AESubscriptionInfo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.lastFocused = null;

      this.handleKeydown = this.handleKeydown.bind(this);

      this.querySelectorAll('[data-ae-subinfo-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      const overlay = this.querySelector('.ae-subinfo__overlay');
      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-ae-subscription-info-trigger]');
        if (!trigger) return;
        event.preventDefault();
        this.lastFocused = trigger;
        this.open();
      });
    }

    open() {
      if (this.hasAttribute('open')) return;
      this.setAttribute('open', '');
      document.body.classList.add('ae-subinfo-open');
      document.addEventListener('keydown', this.handleKeydown);
      const closeBtn = this.querySelector('[data-ae-subinfo-close]');
      if (closeBtn) {
        requestAnimationFrame(() => closeBtn.focus({ preventScroll: true }));
      }
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      document.body.classList.remove('ae-subinfo-open');
      document.removeEventListener('keydown', this.handleKeydown);
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus({ preventScroll: true });
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      }
    }
  }

  window.AESubscriptionInfo = AESubscriptionInfo;
  customElements.define('ae-subscription-info', AESubscriptionInfo);

  window.aeSubscriptionInfoOpen = function () {
    const panel = document.querySelector('ae-subscription-info');
    if (panel && typeof panel.open === 'function') panel.open();
  };
  window.aeSubscriptionInfoClose = function () {
    const panel = document.querySelector('ae-subscription-info');
    if (panel && typeof panel.close === 'function') panel.close();
  };
}
